/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PatchCollaborationToolConfigDto = {
    type: PatchCollaborationToolConfigDto.type;
};

export namespace PatchCollaborationToolConfigDto {

    export enum type {
        JIRA = 'JIRA',
        SERVICENOW = 'SERVICENOW',
    }


}
